(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 9904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(9096);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates_FeaturesTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./src/components/atoms/AccordionCanvas.tsx + 1 modules
var AccordionCanvas = __webpack_require__(7973);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./src/components/elements/EarlyAccessSection.tsx
var EarlyAccessSection = __webpack_require__(3192);
// EXTERNAL MODULE: ./src/components/layouts/MainLayout.tsx + 5 modules
var MainLayout = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/components/atoms/Quote.tsx
var Quote = __webpack_require__(715);
// EXTERNAL MODULE: ./src/components/meta/SEO.tsx
var SEO = __webpack_require__(8897);
// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/use-immer/dist/use-immer.module.js
var use_immer_module = __webpack_require__(57);
// EXTERNAL MODULE: ./src/components/navigations/StickyFeatureNav.module.css
var StickyFeatureNav_module = __webpack_require__(2846);
var StickyFeatureNav_module_default = /*#__PURE__*/__webpack_require__.n(StickyFeatureNav_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/navigations/StickyFeatureNav.tsx
// import node_modules






// import styles


// define component
var StickyFeatureNav = function() {
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("features").t;
    // init states
    var _useImmer = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(false), 2), isStickyState = _useImmer[0], setIsStickyState = _useImmer[1];
    var _useImmer1 = (0,_sliced_to_array/* default */.Z)((0,use_immer_module/* useImmer */.x)(""), 2), visibleSection = _useImmer1[0], setVisibleSection = _useImmer1[1];
    // init refs
    var headerRef = /*#__PURE__*/ react.createRef();
    // init vars
    var sections = react.useMemo(function() {
        return t("features", {
            returnObjects: true
        });
    }, [
        t
    ]);
    // init func
    var onGetDimensions = react.useCallback(function(element) {
        var height = ((element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) || {}).height;
        var offsetTop = element === null || element === void 0 ? void 0 : element.offsetTop;
        var offsetBottom = offsetTop + height;
        return {
            height: height,
            offsetTop: offsetTop,
            offsetBottom: offsetBottom
        };
    }, []);
    var onScrollTo = react.useCallback(function(sectionId) {
        var element = document.getElementById(sectionId);
        if (element) {
            var offset = 56; // sticky nav height
            window.scroll({
                top: element.offsetTop - offset,
                left: 0,
                behavior: "smooth"
            });
        }
    }, []);
    var onHandleScroll = react.useCallback(function() {
        // get vars
        var _onGetDimensions = onGetDimensions(headerRef.current), headerHeight = _onGetDimensions.height;
        var scrollPosition = window.scrollY + headerHeight + headerHeight + headerHeight;
        // find selected section
        var selected = sections === null || sections === void 0 ? void 0 : sections.find(function(param) {
            var sectionId = param.id;
            var element = document.getElementById(sectionId);
            if (element) {
                var _onGetDimensions = onGetDimensions(element), offsetBottom = _onGetDimensions.offsetBottom, offsetTop = _onGetDimensions.offsetTop;
                return scrollPosition > offsetTop && scrollPosition < offsetBottom + headerHeight;
            }
            return false;
        });
        // update buttons while scrolling
        if (selected && selected.id !== visibleSection) {
            setVisibleSection(selected.id);
            setIsStickyState(true);
            // horizontally scroll button into view
            var navbar = document.getElementById("feature-nav");
            var button = document.getElementById("button-".concat(selected.id));
            if (navbar && button) {
                var _button_getBoundingClientRect = button.getBoundingClientRect(), left = _button_getBoundingClientRect.left, width = _button_getBoundingClientRect.width;
                if (left > window.innerWidth - width) {
                    navbar.scrollLeft = left;
                } else if (left - width < 0) {
                    navbar.scrollLeft = left;
                }
            }
        // hide when above or below sections
        } else if (!selected && visibleSection) {
            // update state
            setVisibleSection("");
            setIsStickyState(false);
        }
    }, [
        headerRef,
        onGetDimensions,
        sections,
        setVisibleSection,
        setIsStickyState,
        visibleSection
    ]);
    // handle data changes
    react.useEffect(function() {
        // init scroll
        // https://codedaily.io/tutorials/Sticky-Header-with-Highlighting-Sections-on-Scroll
        onHandleScroll();
        // listen to scroll changes
        window.addEventListener("scroll", onHandleScroll);
        // unubscribe on unmount
        return function() {
            window.removeEventListener("scroll", onHandleScroll);
        };
    }, [
        onHandleScroll
    ]);
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: classnames_default()((StickyFeatureNav_module_default()).navigation, isStickyState && (StickyFeatureNav_module_default())["is-sticky"]),
        ref: headerRef,
        id: "feature-nav",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (StickyFeatureNav_module_default()).container,
            children: sections.map(function(section) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Button */.zx, {
                    buttonId: "button-".concat(section.id),
                    color: visibleSection === section.id ? "ultraLight" : "naked",
                    onClick: function() {
                        return onScrollTo(section.id);
                    },
                    text: section.label
                }, section.id);
            })
        })
    });
};
/* harmony default export */ var navigations_StickyFeatureNav = (StickyFeatureNav);

;// CONCATENATED MODULE: ./src/components/templates/FeaturesTemplate.tsx
// import node_modules





// import component








// define page
var FeaturesTemplate = function(param) {
    var hrefLang = param.hrefLang;
    // init hooks
    var t = (0,useTranslation/* useTranslation */.$)("features").t;
    // init render
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
                        bgColor: "anakiwa",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "25px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "anakiwa",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                            cols: "ml",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                    alignment: "center",
                                    tag: "h1",
                                    children: t("hero.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: t("hero.intro")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "anakiwa",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "25px",
                            tabletHeight: "25px",
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navigations_StickyFeatureNav, {}),
                    t("features", {
                        returnObjects: true
                    }).map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionCanvas/* default */.Z, {
                            accordionItems: feature.items,
                            columnReverse: index % 2 !== 0,
                            hasShadow: false,
                            sectionId: feature.id,
                            IntroContent: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                            alignment: "left",
                                            tag: "label",
                                            children: feature.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                            mobileHeight: "12px",
                                            tabletHeight: "12px",
                                            height: "12px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                                            alignment: "left",
                                            tag: "h2",
                                            children: feature.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Text */.xv, {
                                            alignment: "left",
                                            size: "large",
                                            children: feature.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                                            mobileHeight: "8px",
                                            tabletHeight: "8px",
                                            height: "8px"
                                        })
                                    ]
                                });
                            }
                        }, feature.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "energyYellow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote["default"], {
                        bgColor: t("testimonial.bgColor"),
                        color: t("testimonial.color"),
                        colorDark: t("testimonial.colorDark"),
                        image: t("testimonial.image"),
                        jobTitle: t("testimonial.jobTitle"),
                        name: t("testimonial.name"),
                        quote: t("testimonial.quote"),
                        snippet: t("testimonial.snippet"),
                        snippetDark: t("testimonial.snippetDark")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        bgColor: "energyYellow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            mobileHeight: "50px",
                            tabletHeight: "50px",
                            height: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyAccessSection["default"], {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Spacer */.LZ, {
                            height: "100px"
                        })
                    })
                ]
            })
        ]
    });
};
FeaturesTemplate.propTypes = {
    hrefLang: prop_types.string.isRequired
};
/* harmony default export */ var templates_FeaturesTemplate = (FeaturesTemplate);


/***/ }),

/***/ 9096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_templates_FeaturesTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2670);
// import node_modules



// import component

// define page
var FeaturesPage = function(param) {
    var hrefLang = param.hrefLang;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_FeaturesTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        hrefLang: hrefLang
    });
};
FeaturesPage.propTypes = {
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (FeaturesPage);


/***/ }),

/***/ 2846:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"storyliner-DhfxZX","navigation":"storyliner-lxkEhj","is-sticky":"storyliner-b12x9l"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,6116,675,6880,6395,9774,2888,179], function() { return __webpack_exec__(9904); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);